export const formatBitrate = (bitrate: number) => {
  if (bitrate >= 1000000) {
    return `${(bitrate/1000000).toFixed(1)} Mb/s`
  }
  if (bitrate >= 1000) {
    return `${(bitrate/1000).toFixed(1)} Kb/s`
  }
  return `${bitrate} b/s`
}
